import { PropsWithoutRef } from "react";

export const ContentWrapper = ({
  children,
}: Omit<PropsWithoutRef<JSX.IntrinsicElements["div"]>, "className">) => (
  <div className="py-8 mx-auto max-w-screen-2xl sm:p-4 lg:p-8">{children}</div>
);
